import type { Phrases } from '../Phrases.d';

import React from 'react';
import { useWatch } from 'react-hook-form';
import { useFormContext } from '../../../../components/react-hook-form/FormContext';
import { TextField } from '/react4xp/components/react-hook-form/TextField';
import { Span } from '../../../../components/Element';
import {
	type ColorName,
	type SubstanceForm,
	COLOR_NAME,
	COMMON_FIELD_NAME,
	SUBSTANCE_FORM,
} from '../constants';

export const CapsulePowderColorOtherTextField = ({
	phrases,
}: {
	phrases: Phrases;
}): React.JSX.Element => {
	const {
		control,
	} =	useFormContext();
	const substanceForm: SubstanceForm = useWatch({
		control, name: COMMON_FIELD_NAME.SUBSTANCE_FORM,
	}) as SubstanceForm;
	const capsulePowderColors: ColorName[] = useWatch({
		control, name: COMMON_FIELD_NAME.CAPSULE_POWDER_COLOR,
	}) as ColorName[];
	const capsulePowderColorLabel = phrases['notificationForm.common.capsulePowderColorField.label'];
	const label = phrases['notificationForm.common.colorOtherField.label'];
	return (
		<TextField
			errorSummaryLabel={`${capsulePowderColorLabel} - ${label}`}
			fullWidth
			label={<Span textSize='lg'>{label}</Span>}
			name={COMMON_FIELD_NAME.CAPSULE_POWDER_COLOR_OTHER}
			showIf={
				() => substanceForm === SUBSTANCE_FORM.CAPSULE
					&& capsulePowderColors?.includes(COLOR_NAME.OTHER)
			}
		/>
	);
};
